import React from 'react';
import './Home.scss';
import { Link } from 'react-router-dom';

const Home = () => {

  return (
    <div className="home-wrapper">
      <div className="screen">
        <div className="title-wrapper">
          <h1 className="screen-title">General Concrete</h1>
        </div>
        <ul className="screen-undertitle">
          <li className='screen-undertitle-item'>BASEMENT AND GARAGE SLABS</li>
          <li className='screen-undertitle-item'>CONCRETE FOUNDATION WALLS</li>
          <li className='screen-undertitle-item'>WALKWAYS AND CONCRETE STAIRS</li>
          <li className='screen-undertitle-item'>FORMING AND FOOTING</li>
          <li className='screen-undertitle-item'>FOUNDATION WATERPROOFING</li>
          <li className='screen-undertitle-item'>REBAR INSTALLATION</li>
        </ul>
      </div>
      <div className='services'>
        <h5 className='services-title'>
          Products
        </h5>
        <div className='services-wrapper'>
          <div className='services-item'>
            <div className="services-image-basement all-serv">
              <h5 className="item-service-title">
                Basement and garage slabs
              </h5>
            </div>
            <div className="services-text">
              <p className="item-article">
              Beneath the vibrant life of any home or establishment lies a silent guardian – the slab. Particularly in basements and garages, the right slab ensures stability, durability, and a level surface that stands the test of time. These are spaces of utility, storage, and, in some cases, leisure. Ensuring they have the right foundation is paramount.
              </p>
            </div>
          </div>
          <div className='services-item'>
            <div className="services-image-foundation all-serv">
              <h5 className="item-service-title">
                Concrete Foundation Walls
              </h5>
            </div>
            <div className="services-text">
              <p className="item-article">
              Concrete foundation walls act as the primary barrier between the vulnerable interiors of a building and the external factors that threaten its structural integrity. These walls are more than just partitions; they’re the bulwark that stands against nature’s forces and time’s wear.
              </p>
            </div>
          </div>
          <div className='services-item'>
            <div className="services-image-walkways all-serv">
              <h5 className="item-service-title">
                Walkways and Concrete Stairs
              </h5>
            </div>
            <div className="services-text">
              <p className="item-article">
              A well-designed walkway or staircase can dramatically elevate the appearance of any property, making it more inviting and aesthetically pleasing. Quality exterior additions such as walkways and stairs can add significant value to a property, ensuring increased ROI for homeowners.
              </p>
            </div>
          </div>
          <div className='services-item'>
            <div className="services-image-forming all-serv">
              <h5 className="item-service-title">
                Forming and Footing
              </h5>
            </div>
            <div className="services-text">
              <p className="item-article">
              Forming and footing set the stage for the entire construction process. These foundational steps determine the stability, strength, and durability of a structure. Think of it as the roots of a tree; they remain unseen, but their health and depth are what give the tree its strength and resilience.
              </p>
            </div>
          </div>
          <div className='services-item'>
            <div className="services-image-waterproofing all-serv">
              <h5 className="item-service-title">
                Foundation Waterproofing
              </h5>
            </div>
            <div className="services-text">
              <p className="item-article">
              Every building, be it a towering skyscraper or a humble abode, holds within its walls stories, memories, and dreams. But without a robust defense against nature’s unpredictable elements, these stories risk an untimely end. That defense is foundation waterproofing – the unsung guardian that protects our structures from moisture’s damaging grip.
              </p>
            </div>
          </div>
          <div className='services-item'>
            <div className="services-image-rebar all-serv">
              <h5 className="item-service-title">
                Rebar Installation
              </h5>
            </div>
            <div className="services-text">
              <p className="item-article">
              Architectural marvels, from the towering skyscrapers that define city horizons to the cozy homes that resonate with warmth, owe their resilience to an unseen hero: rebar. Beneath the layers of concrete lies a network of steel reinforcements, ensuring that these structures stand tall against the test of time and nature.
              </p>
            </div>
          </div>
          <div className='services-item'>
            <div className="services-image-works">
              <Link to="/works" className="grid__link">
                Our Projects
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;